import React from 'react';
import StartNetworkingStep from '../../../StartNetworkingStep/StartNetworkingStep';
import {useEventSettings} from '../../../../../../data/hooks/events/useEventSettings';
import {useMeetings} from '../../../../../../data/hooks/meeting/useMeetings';
import {useI18n} from '../../../../../../data/hooks/i18nHooks';

function StepViewMeetings(props) {
    const {eventId} = props,
        i18n = useI18n(),
        settings = useEventSettings(eventId),
        visible = !settings.disable_meetings,
        meetings = useMeetings(eventId),
        complete = meetings.length > 0;

    // console.log('DEBUG visible value', visible, settings);

    return (
        <StartNetworkingStep
            href={['/events', eventId, 'meetings'].join('/')}
            visible={visible}
            complete={complete}
            disabledHint={i18n['start.view_meetings.disabled']}>
            {i18n['start.view_meetings']}
        </StartNetworkingStep>
    );
}

export default StepViewMeetings;
